module.exports = __webpack_public_path__ + "img/slider-alertduedate.cd3350c8.png";